import { render, staticRenderFns } from "./ProductFamilyEmissionByLcaStage.vue?vue&type=template&id=87adba02"
import script from "./ProductFamilyEmissionByLcaStage.vue?vue&type=script&lang=js"
export * from "./ProductFamilyEmissionByLcaStage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports